module.exports = new __parcel__URL__("Charlie_Text-Light.02cd4b54.woff2").toString();